import axios from "axios"
import { getToken, refreshToken } from "src/engine/modules/token"

const addDefaultBaseURL = (baseURL, params) => ({ baseURL, ...params })

// Конструктор запроса с авторизацией
export default ({
  baseURL, // Базовый урл
  isAuthError, // Решает, является ли пришедшая ошибка ошибкой авторизации
  insertToken, // Вставляет токен в параметры запроса
}) => params =>
  getToken()
    .then(token =>
      axios(insertToken(token, addDefaultBaseURL(baseURL, params))),
    )
    .catch(error => {
      if (
        error.response &&
        isAuthError(error.response.status, error.response.data)
      ) {
        return refreshToken()
          .then(() => getToken())
          .then(token =>
            axios(insertToken(token, addDefaultBaseURL(baseURL, params))),
          )
      }
      throw error
    })
